import React from "react";
import { useStoreState } from "../hooks/ep";
import { useEnsureData } from "../helpers/use-ensure-data";
import { Spinner } from "@blueprintjs/core";
import { ColDef } from "@ag-grid-community/core/dist/es6/entities/colDef";
import AgTable from "./AgTable/ag_table";
import { UserAction } from "../user-actions/user_actions";
import _ from "lodash";

export function CustomerInteractionsTable(props) {
  const loading = useEnsureData("customerInteractions");
  return loading ? <Spinner /> : <CustomerInteractionsTableInner {...props} />;
}

function CustomerInteractionsTableInner({
  finalizeRowData = (v) => v,
  finalizeColDefs = (v) => v,
  ...restProps
}) {
  let rowData = useStoreState(
    (s) => s.customerInteractions.initialData
  ) as UserAction[];
  rowData = _.sortBy(rowData, "submitted_at")
    .reverse()
    .map((row) => ({
      ...row,
      callTopics: getMSValuesString(row, "callTopics"),
      customerIssues: getMSValuesString(row, "customerIssues"),
    }));
  return (
    <AgTable
      tableName="customerInteractions"
      rowData={finalizeRowData(rowData)}
      columnDefs={finalizeColDefs(COLUMN_DEFS)}
      {...restProps}
    />
  );
}

function getMSValuesString(row: UserAction, fieldName: string): string {
  const {
    action_payload: {
      form_payload: { [fieldName]: msValues },
    },
  } = row;
  return msValues.map(({ longName }) => longName).join(", ");
}

const COLUMN_DEFS: ColDef[] = [
  {
    headerName: "Submitted By",
    field: "submitted_by",
    type: "categoryColumn",
    // @ts-ignore
    valueGetter: ({ data }) => data.submitted_by.split("@")[0],
  },
  {
    headerName: "Submitted At",
    field: "submitted_at",
    type: "timestampColumn",
  },
  {
    headerName: "Submit Date",
    field: "submitted_at",
    type: "dateColumn",
  },
  // { headerName: "Action", field: "action_code", type: "categoryColumn" },

  {
    headerName: "Customer Name",
    field: "action_payload.customer_snapshot.CustomerName",
    type: "textColumn",
  },
  {
    headerName: "Customer Number",
    field: "action_payload.customer_snapshot.CustomerNumber",
    type: "textColumn",
  },
  {
    headerName: "Under Salesforce Review",
    field: "action_payload.form_payload.underSalesforceReview",
    type: "categoryColumn",
  },
  {
    headerName: "Topics",
    field: "callTopics",
    type: "textColumn",
    width: 200,
    suppressSizeToFit: true,
    tooltipField: "callTopics",
  },
  {
    headerName: "Issues",
    field: "customerIssues",
    type: "textColumn",
    width: 200,
    suppressSizeToFit: true,
    tooltipField: "customerIssues",
  },
  {
    headerName: "Notes",
    field: "action_payload.form_payload.notes",
    type: "textColumn",
    width: 200,
    suppressSizeToFit: true,
    tooltipField: "action_payload.form_payload.notes",
  },
  {
    headerName: "Attendees",
    field: "action_payload.form_payload.attendees",
    type: "textColumn",
    width: 200,
    suppressSizeToFit: true,
    tooltipField: "action_payload.form_payload.attendees",
  },
  {
    headerName: "Phone Number",
    field: "action_payload.form_payload.phone",
    type: "textColumn",
  },
  {
    headerName: "Sentiment",
    field: "action_payload.form_payload.customerSentiment",
    type: "categoryColumn",
  },
  {
    headerName: "Churn Likelihood",
    field: "action_payload.form_payload.churnLikelihood",
    type: "categoryColumn",
  },
  {
    headerName: "Salesforce Case Opened",
    field: "action_payload.form_payload.salesforceCaseOpened",
    type: "categoryColumn",
  },
  {
    headerName: "Salesforce Case URL",
    field: "action_payload.form_payload.salesforceCaseUrl",
    type: "linkedTextColumn",
    // __linkField: "action_payload.form_payload.salesforceCaseUrl",
  },
];
